<!-- =========================================================================================
  File Name: TabDescription.vue
  Description: User Edit Description Tab content
========================================================================================== -->

<template>
  <div id="tab-description">
    <div class="vx-row">

      <!-- Col 1 -->
      <div class="vx-col w-full md:w-1/2">
        <vs-textarea rows="8" label="Описание" v-model="partnerLocal.descr" />
      </div>

    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" icon-pack="feather" icon="icon-chevron-left" :to="{ name: 'apps-partners-list' }">Назад</vs-button>
          <vs-button class="ml-4 mt-2" icon-pack="feather" icon="icon-rotate-cw" type="border" color="warning" @click="reset_partner">Очистить</vs-button>
          <vs-button class="ml-4 mt-2" icon-pack="feather" icon="icon-plus" color="success" @click="save_changes" :disabled="!validateForm">Создать</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    partner: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      partnerLocal: this.partner,
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.partnerLocal.company && this.partnerLocal.phone
    }
  },
  methods: {
    save_changes() {
      if(!this.validateForm) return
      
      this.$store.dispatch("partner/createPartner", this.partnerLocal)
      .then(() => {
        this.$router.push({ name:'apps-partners-list' });
      })

    },
    reset_partner() {
      this.partnerLocal = { state: 0 }
    },
  },
}
</script>
